// extracted by mini-css-extract-plugin
export default {"GitHubAvatar":"User-module__GitHubAvatar__lFK9fgH","Link":"User-module__Link__UeRa1lp"};